import { stepAndRouteMap } from "src/constants";
import useCleverTapEvents from "./useGetEvents";
import { PAGE_LANDING_EVENT } from "./constant";

export type IKey = 'gender' |
'maritalStatus' |
'occupation' |
'incomeSegment' |
'tradingExperience' |
'fatherName' |
'segmentSelection';

const usePageLandingsEvents = () => {
  const { TriggerEvent } = useCleverTapEvents();

  const TriggerPageLandingEvents = (step:string) => {
    if (step && step !== "/") {
      // mobile
      if (step === stepAndRouteMap.mobile_verification[0]) {
        TriggerEvent(PAGE_LANDING_EVENT.mobileLanding, {});
      } else if (step === stepAndRouteMap.mobile_verification[1]) {
        TriggerEvent(PAGE_LANDING_EVENT.mobileOtpLanding, {});
      } else if (step === stepAndRouteMap.email_verification[0]) {
        // email
        TriggerEvent(PAGE_LANDING_EVENT.emailLanding, {});
      } else if (step === stepAndRouteMap.email_verification[1]) {
        TriggerEvent(PAGE_LANDING_EVENT.emailOtpLanding, {});
      } else if (step === stepAndRouteMap.pan_verification[0]) {
        // pan
        TriggerEvent(PAGE_LANDING_EVENT.panLanding, {});
      } else if (step === stepAndRouteMap.aadhaar_verification[0]) {
        // kyc
        TriggerEvent(PAGE_LANDING_EVENT.kycLanding, {});
      } else if (step === stepAndRouteMap.liveliness_detection[0]) {
        // liveliness
        TriggerEvent(PAGE_LANDING_EVENT.livelinessLanding, {});
      } else if (step === stepAndRouteMap.signature[0]) {
        // signature
        TriggerEvent(PAGE_LANDING_EVENT.signatureLanding, {});
      } else if (step === stepAndRouteMap.nominee[0]) {
        // nominee
        TriggerEvent(PAGE_LANDING_EVENT.nomineeLanding, {});
      } else if (step === stepAndRouteMap.aadhaar_e_sign_documents[0]) {
        // eSign
        TriggerEvent(PAGE_LANDING_EVENT.eSignLanding, {});
      }
    }
  }

  const PersonalDetailsLanding = (id:IKey) => {
    if (id) {
      if (id === "gender") {
        TriggerEvent(PAGE_LANDING_EVENT.genderLanding, {});
      } else if (id === "maritalStatus") {
        TriggerEvent(PAGE_LANDING_EVENT.maritalStatusLanding, {});
      } else if (id === "occupation") {
        TriggerEvent(PAGE_LANDING_EVENT.occupationLanding, {});
      } else if (id === "incomeSegment") {
        TriggerEvent(PAGE_LANDING_EVENT.incomeLanding, {});
      } else if (id === "tradingExperience") {
        TriggerEvent(PAGE_LANDING_EVENT.experienceLanding, {});
      } else if (id === "fatherName") {
        TriggerEvent(PAGE_LANDING_EVENT.parentNameLanding, {});
      } else if (id === "segmentSelection") {
        TriggerEvent(PAGE_LANDING_EVENT.segmentLanding, {});
      }
    }
  }

  return { TriggerPageLandingEvents, PersonalDetailsLanding }
}

export default usePageLandingsEvents;
